let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("42QUw"), load("58kAD"), load("b7Mng"), load("cmxKv"), load("8m15Y")]).then(() => parcelRequire('jsyvA'));